import { useGSAP } from '@gsap/react';
import { motion } from 'framer-motion';
import gsap from 'gsap';
import { useRef } from 'react';
import { exploreVideo, exploreVideo1, exploreVideo2 } from '../utils';
import { animateWithGsap } from '../utils/animations';
import { GlowingCard } from './ui/GlowingCard';

const Features = () => {
  const videoRef = useRef();
  const videoRef2 = useRef();
  const videoRef3 = useRef();

  useGSAP(() => {
    gsap.to('#exploreVideo', {
      scrollTrigger: {
        trigger: '#exploreVideo',
        toggleActions: 'play pause reverse restart',
        start: '-10% bottom',
      },
      onComplete: () => {
        if (videoRef.current) videoRef.current.play();
      }
    })

    animateWithGsap('#features_title', { y:0, opacity:1})
    animateWithGsap(
      '.g_grow',
      { scale: 1, opacity: 1, ease: 'power1' },
      { scrub: 5.5 }
    );
    animateWithGsap(
      '.g_text',
      {y:0, opacity: 1,ease: 'power2.inOut',duration: 1}
    )
  }, []);

  return (
    <section className="h-full common-padding bg-zinc relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-zinc-900 to-black opacity-50" />
      
      <div className="screen-max-wdith relative z-10">
        <div className="mb-12 w-full">
          <motion.h1 
            id="features_title" 
            className="section-heading bg-gradient-to-r from-white via-cyan-200 to-white bg-clip-text text-transparent"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Explore the full drop.
          </motion.h1>
        </div>
        
        <div className="flex flex-col justify-center items-center overflow-hidden">
          <motion.div 
            className="mt-32 mb-24 pl-24"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-5xl lg:text-7xl font-semibold bg-gradient-to-r from-cyan-300 via-white to-cyan-300 bg-clip-text text-transparent">Zero-Coin.</h2>
            <h2 className="text-5xl lg:text-7xl font-semibold bg-gradient-to-r from-gray-300 via-white to-gray-300 bg-clip-text text-transparent">Encrypted in Silver.</h2>
          </motion.div>

          <div className="flex-center flex-col sm:px-10">
            <motion.div 
              className="relative h-[50vh] w-full flex items-center rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-cyan-500/10"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
            >
              <video playsInline id="exploreVideo" className="w-full h-full object-cover object-center" preload="none" muted autoPlay ref={videoRef}>
                <source src={exploreVideo} type="video/mp4" />
              </video>
            </motion.div>

            <div className="flex flex-col w-full relative">
              <div className="feature-video-container gap-5">
                <motion.div 
                  className="overflow-hidden flex-1 h-[50vh] mt-5 rounded-2xl border border-white/10 shadow-xl"
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  <video playsInline id="exploreVideo1" className="w-full h-full object-cover object-center" preload="none" muted autoPlay ref={videoRef2}>
                    <source src={exploreVideo2} type="video/mp4" />
                  </video>
                </motion.div>
                <motion.div 
                  className="overflow-hidden flex-1 h-[50vh] mt-5 rounded-2xl border border-white/10 shadow-xl"
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  <video playsInline id="exploreVideo2" className="w-full h-full object-cover object-center" preload="none" muted autoPlay ref={videoRef3}>
                    <source src={exploreVideo1} type="video/mp4" />
                  </video>
                </motion.div>
              </div>

              <div className="feature-text-container mt-10 gap-8">
                <GlowingCard 
                  glowColor="cyan" 
                  className="flex-1"
                  icon={<span className="text-2xl">◈</span>}
                  title="Zero-Coin"
                >
                  <p className="text-gray-300 leading-relaxed text-lg">
                    Zero-Coin is {' '}
                    <span className="text-cyan-400 font-bold bg-cyan-400/10 px-1 rounded">
                      ushering in a new era of digital finance
                    </span>{' '}
                    through a groundbreaking airdrop with Zero-Bank on its very own Zero-Blockchain. Be part of the revolution that leverages{' '}
                    <span className="text-white font-bold bg-white/10 px-1 rounded">
                      state-of-the-art blockchain technology
                    </span>{' '}
                    used in the world's leading financial platforms. Secure your spot in the future of finance today with the Zero-Coin native to Zero-Blockchain!
                  </p>
                </GlowingCard>
                
                <GlowingCard 
                  glowColor="silver" 
                  className="flex-1"
                  icon={<span className="text-2xl">◎</span>}
                  title="Zero-Tokens"
                >
                  <p className="text-gray-300 leading-relaxed text-lg">
                    Zero-Tokens bring rarity to life with a series of {' '}
                    <span className="text-gray-200 font-bold bg-white/10 px-1 rounded">
                      fifty unique digital collectibles
                    </span>,{' '}
                    each representing an extinct animal or soon to be, crafted with precision on the blockchain. Each Zero-Token is not just a collectible, but a{' '}
                    <span className="text-cyan-400 font-bold bg-cyan-400/10 px-1 rounded">
                      symbol of the balance of nature
                    </span>. By owning a Zero-Token, you are preserving the memory of these creatures and supporting innovative conservation efforts.
                  </p>
                </GlowingCard>
              </div>      
            </div>
          </div>
        </div>
      </div>      
    </section>
  )
}

export default Features